import "core-js/modules/es6.object.assign";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useState } from 'react';
import Link from '../../Atoms/Link/Link';
import Select from '../../Atoms/SelectField/SelectField';
import Text from '../../Atoms/Text/Text';
import { ESUWrapper, TopCopyWrapper, Form, PrivacyCopyWrapper, InputField, ButtonWrapper, Title } from './EmailSignUp.style';

var EmailSignUp = function EmailSignUp(_ref) {
  var title = _ref.title,
      topCopy = _ref.topCopy,
      isSuccess = _ref.isSuccess,
      isSchools = _ref.isSchools,
      schoolsCopy = _ref.schoolsCopy,
      selectItems = _ref.selectItems,
      successCopy = _ref.successCopy,
      errorMsg = _ref.errorMsg,
      privacyCopy = _ref.privacyCopy,
      subscribe = _ref.subscribe,
      validate = _ref.validate,
      buttonColor = _ref.buttonColor,
      backgroundColor = _ref.backgroundColor,
      rest = _objectWithoutProperties(_ref, ["title", "topCopy", "isSuccess", "isSchools", "schoolsCopy", "selectItems", "successCopy", "errorMsg", "privacyCopy", "subscribe", "validate", "buttonColor", "backgroundColor"]);

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      age = _useState4[0],
      setAge = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      next = _useState6[0],
      setNext = _useState6[1];

  var handleSubmit = function handleSubmit(e) {
    // Just stopping weird things happening for now when the user submits with the enter key
    // rather than the Submit button
    e.preventDefault();
  };

  var schoolsSelect = React.createElement(React.Fragment, null, React.createElement(Select, {
    hideLabel: true,
    label: "Please choose an option",
    placeholder: "Please choose an option",
    description: "Please choose an option",
    errorMsg: errorMsg,
    options: selectItems,
    value: age,
    onChange: function onChange(event) {
      return setAge(event.target.value);
    }
  }), React.createElement(Text, {
    tag: "p",
    weight: "400",
    size: "m"
  }, schoolsCopy));
  var subscriptionSchoolsForm = React.createElement(Form, {
    onSubmit: function onSubmit(e) {
      return handleSubmit(e);
    }
  }, !next && React.createElement(React.Fragment, null, React.createElement(InputField, {
    name: "email",
    id: "email",
    hasAria: false,
    showLabel: false,
    type: "email",
    errorMsg: errorMsg,
    label: "email",
    placeholder: "example@youremail.com",
    value: value,
    onChange: function onChange(event) {
      return setValue(event.target.value);
    }
  }), React.createElement(ButtonWrapper, {
    backgroundColor: backgroundColor
  }, React.createElement(Link, {
    type: "button",
    color: buttonColor,
    as: "button",
    href: "/#",
    onClick: function onClick() {
      return validate({
        email: value
      }) && setNext(true);
    }
  }, "Next"))), next && React.createElement(React.Fragment, null, schoolsSelect, React.createElement(ButtonWrapper, {
    backgroundColor: backgroundColor
  }, React.createElement(Link, {
    type: "button",
    color: buttonColor,
    as: "button",
    href: "/#",
    onClick: function onClick() {
      return validate({
        email: value,
        age: age
      }) && subscribe({
        email: "".concat(value),
        age: "".concat(age)
      });
    }
  }, "Subscribe"))));
  var subscriptionForm = React.createElement(Form, {
    onSubmit: function onSubmit(e) {
      return handleSubmit(e);
    }
  }, React.createElement(InputField, {
    name: "email",
    id: "email",
    hasAria: false,
    showLabel: false,
    type: "email",
    errorMsg: errorMsg,
    label: "email",
    placeholder: "example@youremail.com",
    value: value,
    onChange: function onChange(event) {
      return setValue(event.target.value);
    }
  }), React.createElement(ButtonWrapper, {
    backgroundColor: backgroundColor
  }, React.createElement(Link, {
    type: "button",
    color: buttonColor,
    as: "button",
    href: "/#",
    onClick: function onClick() {
      return validate({
        email: value
      }) && subscribe(value);
    }
  }, "Subscribe")));
  var privacyContainer = React.createElement(PrivacyCopyWrapper, null, privacyCopy);
  return React.createElement(ESUWrapper, Object.assign({
    backgroundColor: backgroundColor
  }, rest), React.createElement(Title, {
    tag: "h2",
    size: "xxl",
    weight: "400",
    family: "Anton",
    uppercase: true
  }, title), (!next || isSuccess) && React.createElement(TopCopyWrapper, null, isSuccess ? successCopy : topCopy), !isSuccess && (isSchools ? subscriptionSchoolsForm : subscriptionForm), privacyContainer);
};

EmailSignUp.defaultProps = {
  backgroundColor: 'deep_violet_dark',
  buttonColor: 'red',
  isSchools: false,
  schoolsCopy: '',
  selectItems: []
};
export default EmailSignUp;